import styled from '@benzinga/themetron';
import { FunctionComponent } from 'react';

import { SpanComponent } from './utils';

export interface LabelProps {
  alignBottom?: boolean;
  alignLeft?: boolean;
  alignRight?: boolean;
  alignTop?: boolean;
  backgroundColor?: string;
  centered?: boolean;
  color?: string;
  flipped?: boolean;
}

export interface LabelCssProps {
  bottom: string;
  left: string;
  margin: string;
  right: string;
  top: string;
  transform: string;
}

const Label: FunctionComponent<React.PropsWithChildren<LabelProps>> = styled(SpanComponent).attrs<
  LabelCssProps & LabelProps
>(props => {
  let right = 'auto';
  let left = 'auto';
  let margin = '0';

  if (props.alignRight || (props.alignLeft && props.flipped)) {
    right = '0';
    left = 'unset';
  } else if (props.alignLeft || (props.alignRight && props.flipped)) {
    left = '0';
    right = 'unset';
  } else if (props.centered) {
    left = 'unset';
    right = 'unset';
    margin = '0 auto';
  }

  return {
    bottom: props.alignBottom ? '0' : 'auto',
    left,
    margin,
    right,
    top: !props.alignBottom && props.alignTop ? '0' : 'auto',
    transform: props.centered ? 'translateX(-50%)' : 'none',
  };
})<LabelProps>`
  bottom: ${props => props.bottom};
  display: inline-block;
  left: ${props => props.left};
  margin: ${props => props.margin};
  position: absolute;
  right: ${props => props.right};
  top: ${props => props.top};
  transform: ${props => props.transform};
  white-space: nowrap;
`;
// label cannot be centered and flipped at the same time.

export default Label;
